export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      formData: {}
    }
  },
  mounted () {
    this.initInput()
  },
  methods: {
    // 初始化 输入框 model
    initInput () {
      for (const key in this.editData) {
        this.$set(this.formData, key, this.editData[key])
      }
    },
    // 确定
    submitHandle () {
      this.$emit('submit', this.formData, this.pageType)
    },
    // 取消
    cancelHandle () {
      this.$emit('cancel')
    }
  },
  watch: {
    'show': function () {
      if (this.show) {
        this.initInput()
      }
    }
  }
}
